import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';

const styles = `
  .mobile-logo {
    display: block;
  }
  .desktop-logo {
    display: none;
  }
  .mobile-title {
    display: block;
  }
  .desktop-title {
    display: none;
  }

  @media (min-width: 768px) {
    .mobile-logo {
      display: none;
    }
    .desktop-logo {
      display: block;
    }
    .mobile-title {
      display: none;
    }
  }

  dialog {
    border: none;
    border-radius: 0;
    padding: 20px;
    font-family: Georgia, serif;
    background: white;
    color: black;
    max-width: 600px;
    width: calc(95vw - 40px);
    border: 3px solid #000;
    max-height: 60vh;
    overflow-y: auto;
  }

  @media (min-width: 768px) {
    dialog {
      padding: 40px;
      width: 90%;
    }
  }

  dialog::backdrop {
    background: rgba(0, 0, 0, 0.3);
  }

  .modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    float: right;
    opacity: 0.8;
    transition: opacity 0.3s ease;
  }

  .modal-close:hover {
    opacity: 1;
  }

  .gig-item {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #000;
  }

  .gig-item:last-child {
    border-bottom: none;
  }

  .gig-date {
    font-weight: bold;
    margin-bottom: 5px;
  }

  .gig-title {
    font-size: 18px;
    margin-bottom: 5px;
  }

  .gig-location {
    opacity: 0.8;
  }
`;

const linkStyle = {
  color: 'black',
  textDecoration: 'none',
  fontSize: '12px',
  fontWeight: 'normal',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  display: 'flex',
  alignItems: 'center',
  transition: 'opacity 0.2s ease',
  opacity: '0.8'
};

async function gigs() {
  const resp = await fetch(
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vSFQDpX9nHfDtZjYFwgAj-HUI-GURnHHfMh_DxyqZ4f1yA6oRHOLczFqr0N8tiZr0b8DnEQsCeVmp6k/pub?gid=0&single=true&output=csv",
  );
  const body = await resp.text();
  const results = Papa.parse(body, { header: true });
  const thegigs = results.data
    .map((d) => {
      const parsedDate = new Date(d.Date);
      return {
        ...d,
        Date: isNaN(parsedDate.getDate()) ? d.Date : parsedDate,
      };
    })
    .filter((g) => g.Date >= new Date() - 365 * 24 * 60 * 60 * 1000);

  return (
    thegigs
      .map((d) => {
        const date = d.Date;
        if (date.constructor === String) {
          return {
            ...d,
            datef: d,
          };
        }
        if (!Intl) {
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const day = date.getDate().toString().padStart(2, "0");
          const datef = `${year}-${month}-${day}`;
          return {
            ...d,
            datef,
          };
        }
        const datef = new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        }).format(date);

        return {
          ...d,
          datef,
        };
      })
  );
}

const AlbumRelease = () => {
  const [thegigs, setGigs] = useState([]);
  const dialogRef = React.useRef(null);

  useEffect(() => {
    (async () => {
      setGigs(await gigs());
    })();
  }, []);

  const { upcomingGigs, pastGigs } = React.useMemo(() => {
    const now = new Date();
    const upcoming = thegigs.filter(gig => gig.Date >= now).sort((a, b) => a.Date - b.Date);
    const past = thegigs.filter(gig => gig.Date < now).sort((a, b) => b.Date - a.Date);
    return { upcomingGigs: upcoming, pastGigs: past };
  }, [thegigs]);

  const closeModal = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
    }
  };
  return (
    <>
      <style>{styles}</style>
      <div style={{
        minHeight: 'calc(var(--vh, 1vh) * 100)',
        backgroundColor: 'transparent',
        fontFamily: 'Georgia, serif',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 20px'
      }}>
        <div className="mobile-logo" style={{ textAlign: 'center' }}>
          <img
            fetchpriority="high"
            src="/images/emblem2025.svg"
            alt="Amina Hocine Emblem"
            style={{
              maxWidth: '200px',
              width: '100%',
              height: 'auto',
              marginBottom: '20px',
              padding: '20px'
            }}
          />
          <h1 className="mobile-title" style={{
            fontSize: '24px',
            fontWeight: 'normal',
            letterSpacing: '3px',
            textTransform: 'uppercase',
            margin: '0 0 40px 0',
            color: 'black',
            wordSpacing: '8px'
          }}>
            AMINA HOCINE
          </h1>
        </div>
        <img
          fetchpriority="high"
          src="/images/bg2025.svg"
          alt="Amina Hocine Logo"
          style={{
            width: '100%',
            maxHeight: '50vh',
            height: 'auto',
            marginBottom: '3%',
          }}
          className="desktop-logo"
        />

      <nav style={{
        display: 'flex',
        gap: '18px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        <a
          href="https://aminahocine.bandcamp.com/album/x3"
          target="_blank"
          rel="noreferrer noopener"
          style={linkStyle}
          onMouseEnter={(e) => e.target.style.opacity = '1.0'}
          onMouseLeave={(e) => e.target.style.opacity = '0.8'}
        >
          X3
        </a>
        <a
          href="/news/atamon-july-news.html"
          style={{ ...linkStyle, textTransform: 'none' }}
          onMouseEnter={(e) => e.target.style.opacity = '1.0'}
          onMouseLeave={(e) => e.target.style.opacity = '0.8'}
        >
          ātamōn
        </a>
        <a
          href="https://www.instagram.com/aaaminaaaminaaaminaaa/"
          target="_blank"
          rel="noreferrer noopener"
          style={linkStyle}
          onMouseEnter={(e) => e.target.style.opacity = '1.0'}
          onMouseLeave={(e) => e.target.style.opacity = '0.8'}
        >
          IG
        </a>
      </nav>
      <a
        href="mailto:info@aminahocine.com"
        style={{
          ...linkStyle,
          textTransform: 'none',
          fontSize: '10px',
          letterSpacing: '1px',
          opacity: '0.5',
          position: 'fixed',
          left: '50%',
          bottom: 'calc(32px + env(safe-area-inset-bottom))',
          transform: 'translateX(-50%)',
        }}
        onMouseEnter={(e) => e.target.style.opacity = '0.8'}
        onMouseLeave={(e) => e.target.style.opacity = '0.5'}
      >
        info@aminahocine.com
      </a>
      </div>

      <dialog ref={dialogRef} onClose={closeModal} onClick={(e) => {
        if (e.target === dialogRef.current) {
          closeModal();
        }
      }}>
        <button className="modal-close" onClick={closeModal}>×</button>
        <h2 style={{ marginTop: 0, textTransform: 'uppercase', letterSpacing: '2px' }}>Live Dates</h2>

        {upcomingGigs.length > 0 && (
          <>
            {upcomingGigs.map((gig, index) => (
              <div key={`upcoming-${index}`} className="gig-item">
                <div className="gig-date">{gig.datef}</div>
                <div className="gig-title">
                  {gig.URL ? (
                    <a href={gig.URL} target="_blank" rel="noreferrer noopener" style={{color: 'black', textDecoration: 'underline'}}>
                      {gig.Title}
                    </a>
                  ) : (
                    gig.Title
                  )}
                </div>
                <div className="gig-location">{gig.Location}</div>
              </div>
            ))}
          </>
        )}

        {pastGigs.length > 0 && (
          <div style={{opacity:"0.5"}}>
            {pastGigs.map((gig, index) => (
              <div key={`past-${index}`} className="gig-item" style={{ opacity: 0.8 }}>
                <div className="gig-date">{gig.datef}</div>
                <div className="gig-title">
                  {gig.URL ? (
                    <a href={gig.URL} target="_blank" rel="noreferrer noopener" style={{color: 'black', textDecoration: 'underline'}}>
                      {gig.Title}
                    </a>
                  ) : (
                    gig.Title
                  )}
                </div>
                <div className="gig-location">{gig.Location}</div>
              </div>
            ))}
          </div>
        )}

        {upcomingGigs.length === 0 && pastGigs.length === 0 && (
          <p>No shows scheduled.</p>
        )}
      </dialog>
    </>
  );
};

export default AlbumRelease;
